import * as moment from 'moment'

export class OrderQueryTransformer {
  static transform (obj) {
    let queryParams = {}

    // old - operation_status
    if (obj.comment) {
      if (obj.commentCreatedAtStart || obj.commentCreatedAtEnd) {
        queryParams.operation_status = obj.comment.join(',')
      } else {
        queryParams.status = obj.comment.join(',')
      }
    }

    // old - modifiedAtStart
    if (obj.commentCreatedAtStart) {

      // Status Change - Start

      let commentCreatedAtStart = moment(obj.commentCreatedAtStart).startOf("day").format();

      queryParams.comment_start = commentCreatedAtStart

      // queryParams.comment_start = obj.commentCreatedAtStart
    
    }

    // old - modifiedAtEnd
    if (obj.commentCreatedAtEnd) {

      // Status Change - End

      let commentCreatedAtEnd = moment(obj.commentCreatedAtEnd).endOf("day").format();
      
      queryParams.comment_end = commentCreatedAtEnd

      // queryParams.comment_end = obj.commentCreatedAtEnd

    }

    // old - workOrder
    if (obj.search) {
      queryParams.search = obj.search
    }

    if (obj.type) {
      queryParams.order_type_id = obj.type
    }

    if (obj.subType) {
      queryParams.order_subtype_id = obj.subType
    }

    // Activity Code
    if (obj.activityCode) {
      queryParams.activity_code_id = obj.activityCode
    }

    if (obj.problemCodeId) {
      queryParams.problem_code_id = obj.problemCodeId
    }

    if (obj.priority) {
      queryParams.priority = obj.priority
    }

    // Old - dateLoggedFrom
    if (obj.releaseDateStart) {

      // Date Logged - Start

      let releaseDateStart = moment(obj.releaseDateStart).startOf("day").format();

      queryParams.release_date_start = releaseDateStart

      // queryParams.release_date_start = obj.releaseDateStart
    

    }

    // Old - dateLoggedTo

    if (obj.releaseDateEnd) {

      // Date Logged - End

      let releaseDateEnd = moment(obj.releaseDateEnd).endOf("day").format();

      // let releaseDateEnd = moment(obj.releaseDateEnd).endOf("day").toISOString();

      queryParams.release_date_end = releaseDateEnd

      // queryParams.release_date_end = obj.releaseDateEnd
    }

    // Old - dueDateStart
    if (obj.requiredFinishStart) {

      // Due Date - Start

      let requiredFinishStart = moment(obj.requiredFinishStart).startOf("day").format();
      
      queryParams.required_finish_date_start = requiredFinishStart

      // queryParams.required_finish_date_start = obj.requiredFinishStart
    
    }

    // Old - dueDateEnd
    if (obj.requiredFinishEnd) {
        
      // Due Date - End

      // let requiredFinishEnd = moment(obj.requiredFinishEnd).endOf("day").format();
      let requiredFinishEnd = moment(obj.requiredFinishEnd).startOf("day").format();
    
      queryParams.required_finish_date_end = requiredFinishEnd

      // queryParams.required_finish_date_end = obj.requiredFinishEnd
    
    }

    // Old - modified_at
    if (obj.modifiedAtStart) {
      queryParams.modified_date_start = obj.modifiedAtStart
    }
    if (obj.modifiedAtEnd) {
      queryParams.modified_date_end = obj.modifiedAtEnd
    }

    if (obj.managed_by) {
      queryParams.managed_by = obj.managed_by
    }

    if (obj.assignedTo) {
      queryParams.assigned_to = obj.assignedTo
    }

    // Old- revisit
    if (obj.returnToSite) {
      queryParams.return_to_site = +obj.returnToSite
    }

    if (obj.claimId) {
      queryParams.claimId = obj.claimId
    }

    // old - councilCommented
    if (obj.hasComments) {
      queryParams.council_commented = obj.hasComments
    }

    // old - reactiveCode
    if (obj.outcomeCodeId) {
      queryParams.outcome_code_id = obj.outcomeCodeId
    }

    // old - responseCode
    if (obj.responsibilityCodeId) {
      queryParams.responsibility_code_id = obj.responsibilityCodeId
    }

    // old = failureCode
    if (obj.failureCodeId) {
      queryParams.failure_code_id = obj.failureCodeId
    }

    // old - repairCode
    if (obj.repairCodeId) {
      queryParams.repair_code_id = obj.repairCodeId
    }

    if (obj.kpiStart) {
      queryParams.kpi_start = obj.kpiStart
    }

    if (obj.kpiFinish) {
      queryParams.kpi_finish = obj.kpiFinish
    }

    if (obj.kpiAppeal) {
      queryParams.kpi_appeal = obj.kpiAppeal
    }

    if (obj.hasAsset !== '') {
      queryParams.has_asset = obj.hasAsset
    }

    if (obj.assetCode !== '') {
      queryParams.asset_code = obj.assetCode
    }

    if (obj.assetThirdPartyCode !== '') {
      queryParams.asset_third_party_code = obj.assetThirdPartyCode
    }

    if (obj.createdByFirmId) {
      queryParams.created_by_firm_id = obj.createdByFirmId
    }

    if (obj.external_firm_id) {
      queryParams.external_firm_id = obj.external_firm_id
    }

    if (obj.firmId) {
      queryParams.firm_id = obj.firmId
    }

    if (obj.regionTagId) {
      queryParams.region_tag_id = obj.regionTagId
    }

    if (obj.issuedTo) {
      queryParams.firm_id = obj.issuedTo
    }


    if (obj.issuedBy) {
      queryParams.created_by_firm_id = obj.issuedBy
    }

    if (obj.contractId) {
      queryParams.contract_id = obj.contractId;
    }

    if (obj.contractType) {
      queryParams.contract_type_tag_id = obj.contractType;
    }

    if (obj.readyToClaim) {
      queryParams.ready_to_claim = obj.readyToClaim
    }

    if (obj.dateChangeRequest) {
      queryParams.date_change_request = obj.dateChangeRequest
    }

    if (obj.unvettedNotes) {
      queryParams.unvetted_notes = obj.unvettedNotes
    }

    if (obj.pendingApproval) {
      queryParams.pending_approval = obj.pendingApproval
    }

    if (obj.tags) {
      queryParams.tags = obj.tags
    }

    if (obj.claimLinesTotal) {
      queryParams.claim_lines_total = obj.claimLinesTotal
    }

    if (obj.claimLinesTotalComparison) {
      queryParams.claim_lines_total_comparison = obj.claimLinesTotalComparison
    }

    if (obj.starred) {
      queryParams.starred = obj.starred;
    }

    if (obj.billingCode) {
      queryParams.billing_code = obj.billingCode;
    }

    if (obj.includeVoid) {
      queryParams.include_void = obj.includeVoid
    }

    if (obj.inDispute) {
      queryParams.in_dispute = obj.inDispute
    }

    if (obj.currentlyInDispute) {
      queryParams.currently_in_dispute = obj.currentlyInDispute
    }

    if (obj.locationAssetId) {
      queryParams.location_asset_id = obj.locationAssetId
    }

    return queryParams
  }
}



// WEBPACK FOOTER //
// ./src/helpers/orders/query.transformer.js